export const ANALOGYCONTEXTUALIZER_PROMPT_NAME = 'analogyContextualizer';